import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupFilter'
})
export class GroupFilterPipe implements PipeTransform {

  transform(data: Array<any>, groupKey): any {
    return data.filter(m=>m.group.key===groupKey);
  }

}
